export default "__VITE_ASSET__CiuMWe4J__"